import { AmplitudeSidebarLabels } from '@/checkout-instore-legacy/constants/AmplitudeConstants'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { isRunningStableOnBrowser } from '@/checkout-instore-legacy/utils/EnvUtils'

export function shouldShowWebErrorMessage(userAgent) {
  return isRunningStableOnBrowser(userAgent)
}

export function getNewWebErrorMessage() {
  return {
    messageId: 'webErrorMessage',
    alertProps: {
      action: {
        label: <FormattedMessage id="webErrorActionLabel" />,
        onClick: () => {
          window.open('http://instore.vtex.com/#download')
        },
      },
    },
  }
}

export function getNewDomainErrorMessage() {
  return {
    messageId: 'errorInstoreRunOnThisDomain',
    messageExtraContext: {
      domain: window.location.host,
    },
    alertProps: {},
  }
}
